import GeneralLayout, {
  GeneralLayoutProps as AccountLayoutProps,
} from "@src/layouts/general"

import SEO from "@src/components/seo"

export default function AccountLayout(props: AccountLayoutProps) {
  return (
    <GeneralLayout {...props}>
      <SEO noIndex={true} title={`My Account | Onyx + Rose`} />
      {props.children}
    </GeneralLayout>
  )
}
